var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "trbo-a-info-text" }, [
    _c("div", { staticClass: "trbo-a-info-text__title" }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "trbo-a-info-text__description" }, [
      _vm._v("\n    " + _vm._s(_vm.description) + "\n  "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }